import * as R from 'ramda';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// feature configs
import { renderSelectGroup } from '../ui';
//////////////////////////////////////////////////

export const isCreateOnBranchDisabled = (values) => R.not(R.propEq(
  GC.TEL_DEFAULT_BRANCH_SELECTED_BRANCH,
  GC.TEL_GENERAL_DEFAULT_BRANCH,
  values,
));

const CreateOnBranchField = (props) => {
  const { field } = props;
  const { values } = useFormikContext();
  const { value, setValue } = field;

  const disabled = isCreateOnBranchDisabled(values);

  useEffect(() => {
    if (R.and(disabled, G.isNotNilAndNotEmpty(value))) setValue('');
  }, [disabled, setValue, value]);

  return renderSelectGroup({ ...props, disabled });
};

export default CreateOnBranchField;
